import clsx from "clsx";
import { isAllDay } from "common";
import React from "react";
import { Experience, Timeslot } from "types";
import { ProductImage } from "@/components/Common/ProductImage";
import { DateInfoLine } from "@/components/Event/EventSummaryTile";

interface DashboardProductTileProps {
    experience: Experience;
    timeslot: Timeslot;
}

export const DashboardProductTile = ({ experience, timeslot }: DashboardProductTileProps) => {
    return (
        <div className={clsx("mb-5 flex space-x-1 rounded-lg bg-gray-lighter p-4")}>
            <ProductImage product={experience} />
            <div className="w-full space-y-2">
                <div className="text-base font-bold leading-4" data-testid="event-summary-experience-name">
                    {experience?.name}
                </div>

                <DateInfoLine
                    date={timeslot.arrivalDatetime}
                    label=""
                    quantity={timeslot.capacity.reserved}
                    allDay={isAllDay(experience)}
                />
            </div>
        </div>
    );
};
